import React, { Component, Suspense } from 'react';
import { Link } from 'react-router-dom';
import {_} from '../../locale';

class SidebarNavigation extends Component {
  constructor(props){
    super(props);
    this.state = {
      activeMenu : props.activeMenu,
      sideBarStatus: props.sideBarStatus ? props.sideBarStatus : 0
    }
  }
  
  render() {
    const {activeMenu, sideBarStatus} = this.props;
    return (
      <section id="sidemenu">
        {
          sideBarStatus
          ?
          null
          :
          <nav className="navbar navbar-expand-md navbar-light p-0">
            <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#collapsibleNavbar"> <span className="navbar-toggler-icon"></span> </button>
          
            <div className="collapse navbar-collapse" id="collapsibleNavbar">
              <ul className="navbar-nav">
                <li className="nav-item mob-logo">
                  <Link to="/login"><img className="img-fluid" src="/assets/images/logo-dark.svg" alt="img" /></Link>
                  <button className="navbar-toggler mt-0" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <span className="custom-navbar-toggler-icon">
                      <img width="16" src="/assets/images/close-icon.svg" alt="img" />
                    </span> 
                  </button>
                </li>
                <li className={`${activeMenu == 'transactions' ? "nav-item active" : "nav-item"}`}> 
                  <Link className="nav-link trans-icon" to="/transactions">Transactions</Link>
                </li>
                <li className={`${activeMenu == 'profile' ? "nav-item active" : "nav-item"}`}> 
                  <Link className="nav-link user-icon" to="/profile">My account</Link> 
                </li>

                <li className={`${activeMenu == 'wallet' ? "nav-item active" : "nav-item"}`}> 
                  <Link className="nav-link wallet-icon-2" to="/wallet">Wallet</Link> 
                </li>
                <li className={`${activeMenu == 'refer' ? "nav-item active" : "nav-item"}`}> 
                  <Link className="nav-link refer-earn-icon-2" to="/refertofriend">Refer & earn</Link> 
                </li>
                <li className={`${activeMenu == 'help' ? "nav-item active" : "nav-item"}`}> 
                  <Link className="nav-link help-icon" to="/faq">Help</Link>
                </li>
                <li className="nav-item"> 
                  <Link className="nav-link signout-icon-2" to="/logout">Sign out</Link> 
                </li>
              </ul>
            </div>
          </nav>
        }
      </section>
    );
  }
}

export default SidebarNavigation;